import {NinchatProperties} from '../../api/types'
import React from 'react'
import {SendTagsProps} from './types'
import SendTagsView from './SendTagsView'

const SendTags = (props: SendTagsProps): React.ReactElement => {
    const {
        disabled,
        isVideoChannel,
        onClose,
        onSaveTags,
        tagIds,
        tags,
    } = props

    const onToggleTag = (tagId: NinchatProperties.TagID): void => {
        const _tagIds = [...tagIds]
        const index = tagIds.indexOf(tagId)

        if (index === -1) {
            _tagIds.push(tagId)
        } else {
            _tagIds.splice(index, 1)
        }

        onSaveTags(_tagIds)
    }

    return (
        <SendTagsView
            disabled={disabled}
            isVideoChannel={isVideoChannel}
            onClose={onClose}
            onToggleTag={onToggleTag}
            tagIds={tagIds}
            tags={tags}
        />
    )
}

export default SendTags
